import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { M_Error, S_Tasks } from '../../common/Types';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import '../goal/goals.css';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import { taskRef } from '../../firebase/refs';
import { getListByParentKey } from '../../firebase/refActions';
import Goal from '../goal/Goal';
import Task from './Task';
import { getLatestUnComTasksFromList } from './taskFuncs';
import { useListVals } from 'react-firebase-hooks/database';

const GoalTask = (props: {
  data: GoalI;
  history: RouteComponentProps['history'];
}) => {
  const { addMessage, user } = useStore();
  const { key } = props.data;

  const [taskRefList] = useListVals<any>(taskRef);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [completeTask, setCompleteTask] = useState<number>(0);
  const [currentTask, setCurrentTask] = useState<DailyTaskI | null>(null);

  useEffect(() => {
    if (!key || !user) return;
    getListByParentKey(
      taskRef,
      key,
      'goal_key',
      (res: { data: DailyTaskI[]; error: any }) => {
        if (res.data) {
          const firstTaskToFinished = getLatestUnComTasksFromList(
            res.data,
            new Date(),
            user,
            key,
            true
          );
          setCurrentTask(firstTaskToFinished[0]);
        } else {
          addMessage({
            type: M_Error,
            content: res.error,
            stateName: S_Tasks,
          });
        }
      }
    );

    return () => {
      taskRef.off();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, completeTask, taskRefList]);

  return (
    <Goal
      data={props.data}
      task={
        <>
          {currentTask && (
            <Task
              data={currentTask}
              onDone={() => setCompleteTask(completeTask + 1)}
            />
          )}
        </>
      }
    />
  );
};

export default GoalTask;
